/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  InvalidSignupReportsDTO,
  InvalidSignupReportsDTOOptional,
  InvalidSignupReportsDTOMetaI,
  InvalidSignupReportsDTOTrackedI,
} from "./invalid-signup-reports-dto";
import {
  InvalidSignupReportsDTOTracked,
  InvalidSignupReportsDTOMeta,
} from "./invalid-signup-reports-dto";

/**
 *
 * @export
 * @interface InvalidSignupReportsResultDTO
 */
export interface InvalidSignupReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {InvalidSignupReportsDTO}
   * @memberof InvalidSignupReportsResultDTO
   */
  invalidSignupReports?: InvalidSignupReportsDTOOptional;
}

export interface InvalidSignupReportsResultDTO extends InvalidSignupReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {InvalidSignupReportsDTO}
   * @memberof InvalidSignupReportsResultDTO
   */
  invalidSignupReports?: InvalidSignupReportsDTO;
}

export interface InvalidSignupReportsResultDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof InvalidSignupReportsResultDTO
   */
  queueId?: string;
  queueIdIsSet: boolean;
  /**
   *
   * @type {InvalidSignupReportsDTO}
   * @memberof InvalidSignupReportsResultDTO
   */
  invalidSignupReports?: InvalidSignupReportsDTOTrackedI;
  invalidSignupReportsIsSet: boolean;
}

transformDatesMap.set(
  "InvalidSignupReportsResultDTO",
  function (model: InvalidSignupReportsResultDTO) {
    const transformDatesinvalidSignupReports = transformDatesMap.get(
      "InvalidSignupReportsDTO",
    );
    if (transformDatesinvalidSignupReports && model.invalidSignupReports) {
      transformDatesinvalidSignupReports(model.invalidSignupReports);
    }
  },
);

export type InvalidSignupReportsResultDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  queueId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  invalidSignupReports: PropertyMeta<InvalidSignupReportsDTOMetaI>;
}>;

export var InvalidSignupReportsResultDTOMeta: InvalidSignupReportsResultDTOMetaI =
  {} as InvalidSignupReportsResultDTOMetaI;
InvalidSignupReportsResultDTOMeta = typeMeta("InvalidSignupReportsResultDTO", {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
  invalidSignupReports: propertyMeta(
    "invalidSignupReports",
    false,
    false,
    false,
    InvalidSignupReportsDTOMeta,
  ),
});

const metaI = InvalidSignupReportsResultDTOMeta;

registerMeta(() => {});

export class InvalidSignupReportsResultDTOTracked implements InvalidSignupReportsResultDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  queueId__I?: string = undefined;
  queueIdIsSet: boolean = false;
  set queueId(v: undefined | string) {
    if (v !== undefined) {
      this.queueId__I = v;
      this.queueIdIsSet = true;
    } else {
      this.queueId__I = v || undefined;
      this.queueIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get queueId() {
    return this.queueId__I;
  }
  invalidSignupReports__I?: InvalidSignupReportsDTOTracked = undefined;
  invalidSignupReportsIsSet: boolean = false;
  set invalidSignupReports(v: undefined | InvalidSignupReportsDTOTracked) {
    if (v !== undefined) {
      this.invalidSignupReports__I = v;
      this.invalidSignupReportsIsSet = true;
    } else {
      this.invalidSignupReports__I = v || undefined;
      this.invalidSignupReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get invalidSignupReports() {
    return this.invalidSignupReports__I;
  }
  constructor(
    config?: InvalidSignupReportsResultDTOOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.invalidSignupReports?.setIds();
  }
  assignFrom(
    config: InvalidSignupReportsResultDTOOptional,
    options?: AssignOptions,
  ): InvalidSignupReportsResultDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.queueId && this.queueIdApplyFilter(optionsRequired.filter)) {
      this.queueId = config.queueId;
      if (optionsRequired.unassign) this.queueIdIsSet = false;
      else this.queueIdIsSet = true;
    }
    if (
      config.invalidSignupReports &&
      this.invalidSignupReportsApplyFilter(optionsRequired.filter)
    ) {
      this.invalidSignupReports = new InvalidSignupReportsDTOTracked(
        config.invalidSignupReports,
        options,
      );
      if (optionsRequired.unassign) this.invalidSignupReportsIsSet = false;
      else this.invalidSignupReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): InvalidSignupReportsResultDTOTrackedI {
    const cloned = {} as InvalidSignupReportsResultDTOTrackedI;
    if (
      this.queueIdIsSetDeep() &&
      this.queueIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.queueIdIsSet = true;
      cloned.queueId = this.queueId;
    } else {
      //cloned.queueIdIsSet = false
    }
    if (
      this.invalidSignupReportsIsSetDeep() &&
      this.invalidSignupReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.invalidSignupReportsIsSet = true;
      cloned.invalidSignupReports =
        this.invalidSignupReports?.removeUnset(filter);
    } else {
      //cloned.invalidSignupReportsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): InvalidSignupReportsResultDTOTrackedI {
    if (!this.queueIdApplyFilter(filter)) this.queueIdIsSet = false;

    if (!this.invalidSignupReportsApplyFilter(filter))
      this.invalidSignupReportsIsSet = false;
    this.invalidSignupReports?.unassignAll(filter);

    return this;
  }
  queueIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportsResultDTOMeta.queueId,
      InvalidSignupReportsResultDTOMeta,
      this.queueId,
      this,
    );
  }
  queueIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.queueIdIsSet && this.queueIdApplyFilter(filter)) return true;

    return false;
  }
  invalidSignupReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      InvalidSignupReportsResultDTOMeta.invalidSignupReports,
      InvalidSignupReportsResultDTOMeta,
      this.invalidSignupReports,
      this,
    );
  }
  invalidSignupReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.invalidSignupReportsIsSet &&
      this.invalidSignupReportsApplyFilter(filter)
    )
      return true;
    return this.invalidSignupReports?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.queueIdIsSetDeep(filter)) return true;
    if (this.invalidSignupReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
